import { platformBrowser } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import { environment } from './environments/environment';

// Init language
initLanguage()
	.then(() => import('./app/module'))
	.then(({ AppModule }) => {
		// Bootstrap the application
		return platformBrowser().bootstrapModule(AppModule);
	})
	.catch(err => console.error(err));

async function initLanguage(): Promise<void> {
	// Load required locale module (needs to be adjusted for different locales)
	return import(
		//@ts-ignore
		`../node_modules/@angular/common/locales/fr.js`
	).then((localeModule) => {
		return registerLocaleData(localeModule.default);
	});
}
